
import CreateSaleOrderRequestLine from './create-sales-order-request-line'
export default class CreateSaleOrderRequestDto {
    clientCode: string;
    customerId:number;
    customerCode: string;
    contactName: string;
    contactPhone: string;
    shippingProvinceId: number;
    shippingDistrictId: number | null;
    shippingWardId: number | null;
    shippingAddressNo: string;
    shippingFullAddress : string;
    warehouseCode: string;
    bizType: string;
    externalCode: string;
    shippingServiceCode: string;
    isClientPickup: boolean;
    isLabelling: boolean;
    isShippable: boolean;
    outboundMode: string;
    inventModel:string;
    cod:number=0;
    shippingFee:number=0;
    packingNote: string;
    shippingNote: string;
    isPreOrder: boolean = false;
    autoCreateSO:boolean = false;
    note: string;
    assetTypeCode: string;
    conditionTypeCode: string;
    lines:Array<any>;
}
